import React from "react"

const CheckmarkIcon = () => {
  return <i className='fa-solid fa-check'></i>
}

export default CheckmarkIcon
